
// 获取实名验证所有数据
export const GET_REAL_NAME_AUTH_ALL_INFO = 'GET_REAL_NAME_AUTH_ALL_INFO'

// 设置实名验证所有数据
export const SET_REAL_NAME_AUTH_ALL_INFO = 'SET_REAL_NAME_AUTH_ALL_INFO'

// 获取实名验证接口数据
export const GET_REAL_NAME_AUTH_DATA = 'GET_REAL_NAME_AUTH_DATA'

// 设置银行卡列表
export const SET_BANK_LIST = 'SET_BANK_LIST'

// 获取银行卡列表
export const GET_BANK_LIST = 'GET_BANK_LIST'

// 修改电话号码
export const UPDATE_CELLPHONE = 'UPDATE_CELLPHONE'

// 修改姓名
export const UPDATE_NAME = 'UPDATE_NAME'

// 修改身份证号
export const UPDATE_ID_CARD_NUM = 'UPDATE_ID_CARD_NUM'

// 修改银行卡号
export const UPDATE_BANK_CARD_NUM = 'UPDATE_BANK_CARD_NUM'

// 获取实名认证状态
export const GET_REAL_NAME_STATE = 'GET_REAL_NAME_STATE'

// 设置实名认证状态
export const SET_REAL_NAME_STATE = 'SET_REAL_NAME_STATE'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/realNameAuth.js